var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTypePaymentMethodIconSizesWeightfilled = function SvgTypePaymentMethodIconSizesWeightfilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ED0006",
    fillRule: "evenodd",
    d: "M10.15 14.025a5.67 5.67 0 0 1-3.666 1.333c-3.12 0-5.65-2.5-5.65-5.583s2.53-5.583 5.65-5.583c1.399 0 2.678.502 3.665 1.333a5.67 5.67 0 0 1 3.665-1.333c3.121 0 5.651 2.5 5.651 5.583s-2.53 5.583-5.65 5.583a5.67 5.67 0 0 1-3.666-1.334",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#F9A000",
    fillRule: "evenodd",
    d: "M10.15 14.025a5.54 5.54 0 0 0 1.984-4.25c0-1.702-.77-3.225-1.985-4.25a5.67 5.67 0 0 1 3.665-1.333c3.121 0 5.651 2.5 5.651 5.583s-2.53 5.583-5.65 5.583a5.67 5.67 0 0 1-3.666-1.334",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF5E00",
    fillRule: "evenodd",
    d: "M10.15 14.025a5.54 5.54 0 0 0 1.985-4.25c0-1.702-.77-3.225-1.986-4.25a5.54 5.54 0 0 0-1.985 4.25c0 1.702.77 3.226 1.985 4.25",
    clipRule: "evenodd"
  })));
};
export default SvgTypePaymentMethodIconSizesWeightfilled;